/* jade-v2-proof.js · section 5 (REVIEWS) and the behaviour of section 6 (CHOOSE). Loaded once, deferred, after jade-v2-core.js.
   REVIEWS: cards are the wall's (product-jade-oil-reviews.liquid; pdp-reviews-wall.js owns filter, sort, lightbox, form). Here:
   laptop columns, folded cards (headline/text/Read more open them), one "show all" tap, "Showing N", stars and helpful votes.
   CHOOSE: radios call SSD.tier.set, the button calls SSD.add('close'), the card follows SSD.tier.on. No form, no second writer.
   All strings come from data attributes Liquid wrote; nothing here prints money or a count. */
(function () {
  var w = window, d = document;
  if (w.__jv2Proof) return;
  w.__jv2Proof = 1;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function track(name, props) { if (w.SSD && w.SSD.track) w.SSD.track(name, props); }
  function reduced() { return !!(w.SSD && w.SSD.reduced); }
  function raf(fn) { (w.requestAnimationFrame || w.setTimeout)(fn, 16); }

  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2.6l2.85 6.06 6.66.83-4.9 4.55 1.28 6.6L12 18.5l-5.89 2.74 1.28-6.6-4.9-4.55 6.66-.83z"/></svg>';

  /* Review order lives in product-jade-oil-reviews.liquid (ranked by impact and realism, Sho 2026-10-06); nothing reorders it here. */

  function initReviews() {
    var sec = d.getElementById('d-reviews');
    if (!sec || sec.classList.contains('jv2-rv-ready')) return;
    var inner = sec.querySelector('.sec-reviews .rv .inner');
    if (!inner) return;
    sec.classList.add('jv2-rv-ready');
    var rlist = d.getElementById('rlist');
    var wb = sec.querySelector('.summary-cta .write-btn');
    if (wb && sec.getAttribute('data-c-ask')) {
      var ask = d.createElement('p'); ask.className = 'jv2-rv-ask'; ask.id = 'jv2-rv-ask'; ask.textContent = sec.getAttribute('data-c-ask');
      wb.parentNode.insertBefore(ask, wb); wb.setAttribute('aria-describedby', 'jv2-rv-ask');
    }

    function kid(sel) { return inner.querySelector(':scope > ' + sel); }
    var head = kid('.rv-head'), sum = kid('.summary');
    if (head && sum) {
      var side = d.createElement('div'), main = d.createElement('div');
      side.className = 'jv2-rv-side'; main.className = 'jv2-rv-main';
      inner.insertBefore(side, head);
      side.appendChild(head); side.appendChild(sum);
      inner.appendChild(main);

      ['.pinned', '.controls', '#rlist', '.loadmore', '.gallery-wrap', '.rv-foot'].forEach(function (s) {
        var el = inner.querySelector(':scope > ' + s);
        if (el) main.appendChild(el);
      });
      inner.classList.add('jv2-rv--js');
    }

    var rv = [head, sum].filter(Boolean);
    rv.forEach(function (el, i) {
      if (el.getBoundingClientRect().top > w.innerHeight) { el.classList.add('d-rv'); el.style.setProperty('--i', i); }
    });
    if (w.SSD && w.SSD.onReady) w.SSD.onReady(function () { if (w.SSD.reveal) w.SSD.reveal(sec); });

    function fillStars(root) {
      each(root.querySelectorAll('[data-stars]'), function (el) {
        if (el.firstChild) return;
        var r = +el.getAttribute('data-stars') || 0, h = '';
        for (var i = 1; i <= 5; i++) h += '<span class="sv' + (i <= r ? ' on' : '') + '">' + STAR + '</span>';
        el.innerHTML = h;
      });
      each(root.querySelectorAll('.distrow .lbl .sv'), function (s) { if (!s.firstChild) s.innerHTML = STAR; });
    }
    fillStars(sec);

    var ns = d.querySelector('[data-pdp-namespace]');
    var wallCovers = !ns || ns.contains(sec);
    function hHash(v) { var h = 2166136261; for (var i = 0; i < v.length; i++) { h ^= v.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0).toString(36); }
    function hKey(b) {
      if (b.dataset.helpfulKey) return b.dataset.helpfulKey;
      var c = b.closest('.review,.pinned'), nm = c && c.querySelector('.nm'), t = c && c.querySelector('h4');
      var raw = [location.pathname, c && c.dataset.date || '', nm && nm.textContent.trim() || '', t && t.textContent.trim() || ''].join('|');
      return (b.dataset.helpfulKey = 'ss-review-helpful-v1:' + hHash(raw));
    }
    function hStored(b) { try { return localStorage.getItem(hKey(b)) === '1'; } catch (e) { return false; } }
    function hSave(b, on) { try { if (on) localStorage.setItem(hKey(b), '1'); else localStorage.removeItem(hKey(b)); } catch (e) { } }
    function hPaint(b, on) {
      var hc = b.querySelector('.hc'), base = parseInt(b.dataset.helpfulBase || '0', 10), ack = b.querySelector('.helpful-ack');
      b.classList.toggle('voted', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? sec.getAttribute('data-c-help-on') : sec.getAttribute('data-c-help-idle'));
      if (hc) { var n = base + (on ? 1 : 0); hc.textContent = n > 0 ? '(' + n + ')' : ''; hc.hidden = n === 0; }
      if (ack) ack.hidden = !on;
    }
    function hPrepare(b) {
      if (b.dataset.helpfulReady === '1') return;
      b.dataset.helpfulReady = '1'; b.setAttribute('type', 'button');
      var hc = b.querySelector('.hc');
      b.dataset.helpfulBase = String(hc ? parseInt(hc.textContent.replace(/\D/g, ''), 10) || 0 : 0);
      var ack = d.createElement('span'); ack.className = 'helpful-ack'; ack.textContent = sec.getAttribute('data-c-help-ack') || ''; ack.hidden = true;
      ack.setAttribute('aria-live', 'polite'); b.appendChild(ack);
      hPaint(b, hStored(b));
    }
    function helpfulAll(root) { each(root.querySelectorAll('.helpful'), hPrepare); }
    if (!wallCovers) {
      helpfulAll(sec);
      sec.addEventListener('click', function (e) {
        var b = e.target.closest && e.target.closest('.helpful'); if (!b) return;
        hPrepare(b);
        var on = b.getAttribute('aria-pressed') !== 'true';
        hSave(b, on); hPaint(b, on);
      });
    }

    var uid = 0;
    function textOf(c) { return c.querySelector('.txt') || c.querySelector('.pin-txt'); }
    function replyOf(c) { return c.querySelector('.reply'); }
    function fit(c) {
      if (c.classList.contains('hidden') || c.classList.contains('jv2-open')) return;
      var x = textOf(c); if (!x) return;
      var rp = replyOf(c);
      c.classList.remove('jv2-fit');
      var hid = x.scrollHeight - x.clientHeight;
      var lh = parseFloat(w.getComputedStyle(x).lineHeight) || 26;

      if (hid > 2 && hid < lh * 1.5) { c.classList.add('jv2-fit'); hid = 0; }
      var over = hid >= lh * 1.5 || !!rp, b = c.querySelector('.jv2-rm');
      if (over && !b) {
        if (!x.id) x.id = 'jv2-rv-' + (++uid) + '-x';
        var rt = rp && rp.querySelector('.rt');
        if (rt && !rt.id) rt.id = x.id.replace(/-x$/, '-r');
        b = d.createElement('button'); b.type = 'button'; b.className = 'jv2-rm';
        b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', x.id + (rt ? ' ' + rt.id : ''));
        b.textContent = sec.getAttribute('data-c-more') || '';
        x.insertAdjacentElement('afterend', b);
      } else if (!over && b) b.remove();
    }
    var cards = function () { return sec.querySelectorAll('.pinned, #rlist > .review'); };
    var mo = null;
    function fitAll() {
      if (mo) mo.disconnect();
      each(cards(), fit);
      fillStars(sec);
      if (mo) observe();
    }
    sec.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('.jv2-rm,h4,.txt,.pin-title,.pin-txt'); if (!t) return;
      var c = t.closest('.review,.pinned'); if (!c) return;
      var b = c.querySelector('.jv2-rm'), open = !c.classList.contains('jv2-open');
      if (!b || (t !== b && !open)) return;
      c.classList.toggle('jv2-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = sec.getAttribute(open ? 'data-c-less' : 'data-c-more') || '';
      if (!open && c.getBoundingClientRect().top < 0) c.scrollIntoView({ block: 'start', behavior: reduced() ? 'auto' : 'smooth' });
      track('review_read', { id: c.id || '', open: open });
    });

    var lm = d.getElementById('loadmore'), status = null;
    function visibleCards() { return sec.querySelectorAll('.pinned, #rlist > .review:not(.hidden)'); }
    if (lm) {
      /* chips and sort start folded (script only); Show more opens them, holding the button still (no scroll anchoring in Safari) */
      inner.classList.add('jv2-rv--fold');
      lm.addEventListener('click', function (e) {
        if (!e.isTrusted) return;
        var y0 = lm.getBoundingClientRect().top;
        inner.classList.remove('jv2-rv--fold');
        w.scrollBy(0, lm.getBoundingClientRect().top - y0);
        var before = visibleCards().length;
        /* 2026-10-30: one event, not a lm.click() loop. The loop fired 7 synthetic clicks per tap and PostHog autocapture logged
           each one, so every Show more tap landed as a $rageclick (22 of 22 in 14 days, all 8 clicks inside 22-59 ms, no human
           second tap) and started a session replay for a tap that had worked. pdp-reviews-wall.js listens and opens the rest. */
        lm.dispatchEvent(new Event('ss:reviews-all'));
        track('review_more', { from: before, shown: visibleCards().length });
        var next = sec.querySelectorAll('#rlist > .review:not(.hidden)')[before - 1];
        if (next) { next.tabIndex = -1; next.focus({ preventScroll: true }); }
      });
      status = d.createElement('p'); status.className = 'jv2-rv-showing'; status.setAttribute('aria-live', 'polite');
      lm.insertAdjacentElement('afterend', status);
    }
    var last = '';
    function paintStatus() {
      if (!status) return;
      var n = visibleCards().length;
      var t = (sec.getAttribute(n === 1 ? 'data-c-showing-one' : 'data-c-showing-many') || '').replace('%n', n);
      if (t !== last) { last = t; status.textContent = t; }
    }


    var pend = 0;
    function observe() { if (rlist) mo.observe(rlist, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] }); }
    if (rlist && w.MutationObserver) {

      mo = new MutationObserver(function () {
        if (pend) return;
        pend = 1; raf(function () { pend = 0; fitAll(); paintStatus(); });
      });
      observe();
    }
    fitAll(); paintStatus();
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(function () { fitAll(); });
    var rt = 0, lastW = w.innerWidth;
    w.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (w.innerWidth !== lastW) { lastW = w.innerWidth; fitAll(); } }, 150);
    });

    w.addEventListener('load', function () { fitAll(); paintStatus(); });
  }

  function initChoose() {
    var sec = d.getElementById('d-choose');
    if (!sec || sec.classList.contains('jv2-choose-ready')) return;
    sec.classList.add('jv2-choose-ready');
    var radios = sec.querySelectorAll('input[name="d-tier"]');
    var btn = d.getElementById('d-atc-choose');
    var priceEl = btn && btn.querySelector('[data-jv2-price]');
    var lblEl = btn && btn.querySelector('[data-jv2-label]');
    if (!radios.length || !btn) return;

    function radioFor(n) { var f = null; each(radios, function (r) { if (+r.value === n) f = r; }); return f; }
    function paint(n, info) {
      var r = radioFor(+n); if (!r) return;
      each(radios, function (x) { x.checked = x === r; });
      var avail = info && typeof info.available === 'boolean' ? info.available : !r.disabled;
      var price = info && info.priceText ? info.priceText : r.getAttribute('data-price-text');
      if (priceEl && price) priceEl.textContent = price;
      btn.disabled = !avail; btn.setAttribute('aria-disabled', avail ? 'false' : 'true');
      if (lblEl) lblEl.textContent = btn.getAttribute(avail ? 'data-c-add' : 'data-c-soldout') || '';
      btn.classList.toggle('jv2-so', !avail);
      var sep = btn.querySelector('[data-jv2-sep]'); if (sep) sep.hidden = !avail;
      if (priceEl) priceEl.hidden = !avail;
    }

    sec.addEventListener('change', function (e) {
      var t = e.target; if (!t || t.name !== 'd-tier' || !w.SSD) return;
      w.SSD.tier.set(+t.value);
    });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      if (w.SSD && w.SSD.add) { e.stopPropagation(); w.SSD.add('close'); return; }
      var hero = d.getElementById('atc');       /* no runtime: send the shopper to the real button */
      if (hero && hero.scrollIntoView) hero.scrollIntoView({ block: 'center' });
    });

    if (w.SSD && w.SSD.onReady && w.SSD.tier) {
      w.SSD.onReady(function () { w.SSD.tier.on(function (n, info) { paint(n, info); }); });
    }
  }

  function boot() { initReviews(); initChoose(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
